import React, { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import ExpandableListIllustration from '../../components/ExpandableListIllustration';
import Quiz from '../../components/Quiz';
import IllustrationBg1 from '../../../../../../assets/civil/frameworks/illustrationBg1.png';
import quizIllustration from '../../../../../../assets/civil/frameworks/quiz-bg.png';
interface ISection4Props {
  settings: any;
}

const Section4: React.FunctionComponent<ISection4Props> = ({ settings }) => {
  const ID = '5';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const updateComponentState = useUpdateComponentState();
  const paragraphSettings = useMemo(
    () => settings?.paragraphs?.[4],
    [settings?.paragraphs]
  );
  const quiz = paragraphSettings?.quiz;

  const handleStepsComplete = useCallback(() => {
    updateComponentState(p_course, p_topic, ID, 'civil-frameworks-section4-1');
  }, [updateComponentState, p_course, p_topic]);

  const handleQuizCompleted = useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'civil-frameworks-section4-question'
    );
  }, [updateComponentState, p_course, p_topic]);

  return (
    <div className="frameworks-section">
      <div className="content-block content-block-steps">
        <ExpandableListIllustration
          id="civil-frameworks-section4-1"
          mainTitle={paragraphSettings?.title}
          subTitle={paragraphSettings?.section3Title}
          description={paragraphSettings?.section3Desc}
          illustration={<img src={IllustrationBg1} alt="" />}
          items={(paragraphSettings?.section3Items || []).map((item: any) => ({
            title: item.title || '',
            content: item.content || '',
          }))}
          onComplete={handleStepsComplete}
        />
      </div>
      <div
        className="content-block topic-quiz"
        id="civil-frameworks-section4-question"
      >
        <Quiz
          title={paragraphSettings?.questionTitle ?? ''}
          description={quiz?.description ?? ''}
          question={quiz?.question ?? ''}
          options={quiz?.options ?? []}
          onCompleted={handleQuizCompleted}
          quizImg={quizIllustration}
        />
      </div>
    </div>
  );
};

export default Section4;
